export default __webpack_public_path__ + "static/media/7.e9781ceb.webp";